
import {
    computed,
    defineComponent,
    onMounted,
    ref,
    toRefs,
    reactive,
} from 'vue'
import { addAppType } from '../request'
export default defineComponent({
    emits: ['close', 'success'],
    setup(props, { emit }) {
        const visible = ref(true)
        const afterClose = () => {
            emit('close')
        }
        const loading = ref(false)
        const handleOk = async () => {
            try {
                const params = {
                    name: name.value,
                }
                loading.value = true
                await addAppType(params)
                loading.value = false
                afterClose()
                emit('success')
            } catch (error) {
                loading.value = false
                console.log(error)
            }
        }
        const name = ref('')
        return {
            visible,
            afterClose,
            handleOk,
            name,
            loading,
        }
    },
})
